export default __webpack_public_path__ + "static/media/footer-program-img-1.9a014dbc.png";